import {Injectable} from '@angular/core';

@Injectable()
export class GnHttpInterceptorConfig {
  public startWithUrl: string;
  public ignoreUrls: string[] = [];
}
